/**
 * 独立权利要求项
 */
export interface DependentClaimItem {
    claim_number: number;
    text: string;
    parent_claim_numbers: number[];
}

export interface IndependentClaimItem {
    /**
     * 权利要求编号
     */
    claim_number: number;
    /**
     * 权利要求全文
     */
    text: string;
    original_text?: string;
    effective_text?: string;
    is_method?: boolean;
    category?: string;
    reason?: string;
    selected?: boolean;
    edited?: boolean;
    revision?: number;
    dependent_claims?: DependentClaimItem[];
}

/**
 * 独立权利要求列表请求参数
 */
export interface IndependentClaimsRequest {
    /**
     * 任务 ID
     */
    task_id: string;
}

/**
 * 独立权利要求列表响应数据
 */
export interface IndependentClaimsData {
    /**
     * 专利公开号
     */
    pn: string;
    /**
     * 文本语言
     */
    lang: string;
    /**
     * 专利内部唯一 ID
     */
    patent_id: string;
    /**
     * 独立权利要求总数
     */
    independent_claims_count: number;
    /**
     * 独立权利要求列表
     */
    independent_claims: IndependentClaimItem[];
    /**
     * 已确认选中的权利要求（仅在确认接口响应中存在）
     */
    selected_claim?: IndependentClaimItem;
}

/**
 * 独立权利要求列表响应
 */
export interface IndependentClaimsResponse {
    /**
     * 请求状态
     */
    status: boolean;
    /**
     * 错误代码
     */
    error_code: number;
    /**
     * 错误消息
     */
    error_msg?: string;
    /**
     * 响应数据
     */
    data?: IndependentClaimsData;
}

/**
 * 确认权利要求请求参数
 */
export interface ConfirmClaimRequest {
    /**
     * 任务 ID
     */
    task_id: string;
    /** 当前勾选的 Claim 及其最终文本，至少一条 */
    claims: Array<{
        claim_number: number;
        text: string;
    }>;
}

/**
 * 确认权利要求响应（响应结构与列表接口一致，新增 selected_claim 字段）
 */
export type ConfirmClaimResponse = IndependentClaimsResponse;

export const IndependentClaimApi = Symbol('IndependentClaimApi');

/**
 * 独立权利要求 API
 */
export interface IndependentClaimApi {
    /**
     * 获取独立权利要求列表
     */
    getIndependentClaims(request: IndependentClaimsRequest): Promise<IndependentClaimsResponse>;

    /**
     * 确认选定的权利要求
     */
    confirmClaim(request: ConfirmClaimRequest): Promise<ConfirmClaimResponse>;
}
